/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { Row, Col, Table, message, Tooltip, Modal, Popconfirm, Button as AntButton, DatePicker, Select, Input as AntInput, Form, Spin } from "antd";
import { SyncOutlined, PaperClipOutlined, EditOutlined, DeleteOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { APIs, getToken, baseURL } from "../../../utils/worker";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import moment from "moment";
import { useRef } from "react";
import "./style.scss";
import axios from "axios";
import { showErrorMessage } from "../../../utils";
import attachmentIcon from "../../../assests/images/paperpin.svg";

const token = getToken();

const ViewBroadcast = (check) => {
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [form] = Form.useForm();
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [messageData, setMessageData] = useState("");
  const [broadcastTo, setBroadcastTo] = useState("");
  const [hubCpZoneList, setHubCpZoneList] = useState([]);
  const [isExistingFileRemoved, setIsExistingFileRemoved] = useState(false);
  const [editorRefreshKey, setEditorRefreshKey] = useState(0);

  const navigate = useNavigate();
  const selectedHubs = Form.useWatch("hub", form);

  const toolbarConfig = {
    fontColor: {
      colors: [
        { color: "hsl(0, 0%, 0%)", label: "Black" },
        { color: "hsl(0, 0%, 30%)", label: "Dim grey" },
        { color: "hsl(0, 0%, 60%)", label: "Grey" },
        { color: "hsl(0, 0%, 90%)", label: "Light grey" },
      ],
    },
    fontBackgroundColor: {
      colors: [
        { color: "hsl(0, 75%, 60%)", label: "Red" },
        { color: "hsl(30, 75%, 60%)", label: "Orange" },
        { color: "hsl(60, 75%, 60%)", label: "Yellow" },
        { color: "hsl(90, 75%, 60%)", label: "Light green" },
        { color: "hsl(120, 75%, 60%)", label: "Green" },
      ],
    },
    toolbar: {
      items: [
        "heading",
        "|",
        "bold",
        "|",
        "fontColor",
        "|",
        "italic",
        "|",
        "link",
        "|",
        "underline",
        "|",
        "strikethrough",
        "|",
        "superscript",
        "subscript",
        "|",
        "bulletedList",
        "numberedList",
        "|",
        "insertTable",
        "|",
        "fontBackgroundColor",
        "|",
        "undo",
        "redo",
      ],
    },
    table: { contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"] },
    language: "en",
  };

  const broadcastToOptions = [
    { label: "All", value: "ALL" },
    { label: "Hub", value: "HUB" },
  ];

  const priorityOptions = [
    { label: "High", value: "HIGH" },
    { label: "Medium", value: "MEDIUM" },
    { label: "Low", value: "LOW" },
  ];
  const tableLoading = {
    spinning: isTableLoading,
    indicator: <SyncOutlined spin />,
  };
  const columns = [
    {
      title: "Sl No",
      dataIndex: "slNo",
      key: "slNo",
      width: 10,
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
      key: "createdOn",
      width: 25,
    },
    {
      title: "Valid From",
      dataIndex: "validFrom",
      key: "validFrom",
      width: 25,
    },
    {
      title: "Valid To",
      dataIndex: "validTo",
      key: "validTo",
      width: 25,
    },
    {
      title: "Message",
      dataIndex: "title",
      key: "title",
      width: 40,
      render: (text, record) => (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span
            className="broadcast-message"
            onClick={() => showMessage(record)}
            style={{ cursor: "pointer" }}
          >
            {text}
          </span>
          {getAttachmentUrl(record) && (
            <Tooltip title="View Attachment">
              <img
                width="25px"
                height="25px"
                style={{ cursor: "pointer" }}
                src={attachmentIcon}
                alt="attachment"
                onClick={() => showMessage(record)}
              />
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      title: "Assigned Hub",
      dataIndex: "broadcastToDtos",
      key: "broadcastToDtos",
      width: 40,
      render: (hubs, record) => {
        if (record.broadcastTo === "ALL") return "ALL";
        if (!hubs || hubs.length === 0) return "";
        if (hubs.length === 1) return hubs[0].name;
        const allHubs = hubs.map((hub) => hub.name).join(", ");
        return (
          <Tooltip title={allHubs}>
            <span style={{ cursor: "pointer" }}>{hubs[0].name}...</span>
          </Tooltip>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      width: 15,
      render: (text, record) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <Tooltip title="Update">
            <EditOutlined
              style={{ color: "#1890ff", cursor: "pointer", fontSize: "18px" }}
              onClick={() => handleEdit(record)}
            />
          </Tooltip>
          <Popconfirm
            title="Are you sure you want to delete this broadcast?"
            onConfirm={() => handleDelete(record.id || record.broadcastId)}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Delete">
              <DeleteOutlined style={{ color: "#ff4d4f", cursor: "pointer", fontSize: "18px" }} />
            </Tooltip>
          </Popconfirm>
        </div>
      ),
    },
  ];

  const handleEdit = (record) => {
    setEditRecord(record);
    setIsExistingFileRemoved(false);
    setEditorRefreshKey(prev => prev + 1);
    setBroadcastTo(record.broadcastTo);
    setMessageData(record.message || "");
    getHubCpZone(record.broadcastTo);
    
    form.setFieldsValue({
      validFrom: record.validFrom ? moment(record.validFrom, "DD/MM/YYYY") : null,
      validTo: record.validTo ? moment(record.validTo, "DD/MM/YYYY") : null,
      broadcastTo: record.broadcastTo,
      hub: record.broadcastToDtos ? record.broadcastToDtos.map(item => item.name) : [],
      title: record.title,
      priority: record.priorityType,
      message: record.message
    });
    
    setIsEditModalVisible(true);
  };

  const handleDelete = async (id) => {
    setIsTableLoading(true);
    try {
      await axios.delete(APIs.baseURL + "/broadcast-service/v1/broadcast/" + id, {
        headers: {
          authorization: token,
        },
      });
      message.success("Broadcast deleted successfully");
      getBroadcastList();
    } catch (error) {
      showErrorMessage(error.response?.data?.message || "Failed to delete broadcast");
      setIsTableLoading(false);
    }
  };

  const getHubCpZone = async (data) => {
    if (!data || data === "ALL") return;
    try {
      let response = await axios.get(
        APIs.baseURL + "/broadcast-service/v1/broadcast/premises/" + data,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (response.status === 200) {
        let temp = response.data.map((e) => ({
          label: e.name ? e.name.charAt(0).toUpperCase() + e.name.slice(1).toLowerCase() : "",
          value: e.name,
        }));
        setHubCpZoneList(temp);
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
    }
  };

  const updateBroadcast = async (values) => {
    setIsUpdating(true);
    let temp = [];
    if (values.hub !== undefined) {
      values.hub.forEach((e) => {
        temp.push({ name: e });
      });
    }

    const payload = {
      broadcastId: editRecord?.id || editRecord?.broadcastId,
      createdOn: editRecord?.createdOn,
      validFrom: values.validFrom && typeof values.validFrom.format === "function" ? values.validFrom.format("DD/MM/YYYY") : values.validFrom,
      validTo: values.validTo && typeof values.validTo.format === "function" ? values.validTo.format("DD/MM/YYYY") : values.validTo,
      title: values.title,
      message: messageData.replace(/<img [^>]*src=["'](data:image\/[^"']+|blob:[^"']+)["'][^>]*>/gi, ""),
      broadcastTo: values.broadcastTo,
      priorityType: values.priority,
      broadcastToDtos: temp,
    };

    if (isExistingFileRemoved) {
      payload.filePath = null;
      payload.fileUrl = null;
      payload.file = null;
      payload.attachmentUrl = null;
      payload.attachment = null;
      payload.mediaPath = null;
      payload.media_path = null;
      payload.file_path = null;
    } else if (!file) {
      payload.filePath = editRecord?.filePath || editRecord?.fileUrl || editRecord?.file || editRecord?.file_path || editRecord?.attachmentUrl || null;
    }

    try {
      const formData = new FormData();
      formData.append(
        "data",
        new Blob([JSON.stringify(payload)], { type: "application/json" })
      );
      if (file) {
        formData.append("file", file);
      }

      await axios.put(
        APIs.baseURL + "/broadcast-service/v1/broadcast",
        formData,
        {
          headers: {
            authorization: token,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      message.success("Broadcast Updated Successfully");
      setIsEditModalVisible(false);
      setFile(null);
      setIsExistingFileRemoved(false);
      getBroadcastList();
    } catch (error) {
      showErrorMessage(error.response?.data?.message || "Something went wrong");
    } finally {
      setIsUpdating(false);
    }
  };

  const removeAttachmentDisplayOnly = () => {
    // Strip and clean attachment-related HTML from the message string
    const attachmentPattern = /(<br\s*\/?>)*(\s)*<b>Attachment:<\/b>.*$/gi;
    const imagePattern = /(<br\s*\/?>)*(\s)*<img.*$/gi;
    const cleanMessage = messageData
      .replace(attachmentPattern, "")
      .replace(imagePattern, "")
      .trim()
      .replace(/(<p>(&nbsp;|\s)*<\/p>|<br\s*\/?>|&nbsp;|\s)+$/gi, "");
    
    setMessageData(cleanMessage);
    form.setFieldsValue({ message: cleanMessage });
    setEditorRefreshKey((prev) => prev + 1);
  };

  const removeExistingAttachment = () => {
    setIsExistingFileRemoved(true);
    removeAttachmentDisplayOnly();
  };

  useEffect(() => {
    getBroadcastList();
  }, [check]);

  const showMessage = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
  };

  const isVideo = (url) => {
    if (!url) return false;
    // Match extensions even if followed by query params or fragments
    return url.match(/\.(mp4|webm|ogg|mov|avi)(\?|#|$)/i);
  };

  const isImage = (url) => {
    if (!url) return false;
    // Match extensions even if followed by query params or fragments
    return url.match(/\.(jpeg|jpg|gif|png|webp)(\?|#|$)/i);
  };

  const isPdf = (url) => {
    if (!url) return false;
    return url.match(/\.pdf(\?|#|$)/i);
  };

  const getFileName = (url) => {
    if (!url) return "";
    const parts = url.split("/");
    const name = parts[parts.length - 1].split("?")[0];
    return decodeURIComponent(name);
  };

  const cleanHtml = (html) => {
    if (!html) return "";
    return html.replace(/(<br\s*\/?>|&nbsp;|\s)+$/gi, "").replace(/<p>(&nbsp;|\s)*<\/p>$/gi, "");
  };

  const getAttachmentUrl = (record) => {
    let url = record?.filePath ||
      record?.file ||
      record?.fileUrl ||
      record?.file_path ||
      record?.attachmentUrl ||
      record?.attachment ||
      record?.mediaPath ||
      record?.media_path;

    if (!url && record?.message) {
      const srcMatch = record.message.match(/src=['"]([^'"]+)['"]/i);
      const hrefMatch = record.message.match(/href=['"]([^'"]+)['"]/i);
      url = srcMatch ? srcMatch[1] : (hrefMatch ? hrefMatch[1] : null);
    }
    return url;
  };

  const getBroadcastList = async () => {
    setIsTableLoading(true);
    try {
      let response = await axios.get(
        APIs.baseURL + "/broadcast-service/v1/broadcast",
        {
          headers: {
            Authorization: token,
            token: token.split("Bearer ")[1],
          },
        }
      );
      let temp = [];
      response?.data?.map((e, index) => {
        temp.push({
          slNo: index + 1,
          ...e
        });
      });
      setDataSource(temp);
      setIsTableLoading(false);
    } catch (error) {
      showErrorMessage(error.response.data.message);
      setIsTableLoading(false);
    }
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  return (
    <div className="master-main-container profile-container">
      <div className="p-1">
        <p className="f-16 fw-500 title-color">Broadcast Message</p>
        <hr className="divider" />
        <Table
          className="table-head-sticky"
          columns={columns}
          dataSource={dataSource}
          loading={tableLoading}
          pagination={{
            itemRender: itemRender,
          }}
        />
      </div>
      <Modal
        title={selectedRecord?.title}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={false}
        width={650}
        className="square-modal"
      >
        <div className="modal-content-wrapper">
          <div
            className="message-content"
            dangerouslySetInnerHTML={{ __html: cleanHtml(selectedRecord?.message) }}
          ></div>
          {getAttachmentUrl(selectedRecord) && 
           !selectedRecord?.message?.includes(getAttachmentUrl(selectedRecord)) && (
            <div className="media-preview">
              {isVideo(getAttachmentUrl(selectedRecord)) ? (
                <video
                  key={getAttachmentUrl(selectedRecord)}
                  width="100%"
                  controls
                  autoPlay
                  muted
                  playsInline
                  src={getAttachmentUrl(selectedRecord)}
                  style={{ borderRadius: "8px" }}
                >
                  Your browser does not support the video tag.
                </video>
              ) : isImage(getAttachmentUrl(selectedRecord)) ? (
                <img
                  src={getAttachmentUrl(selectedRecord)}
                  alt="Attachment"
                  style={{ maxWidth: "100%", borderRadius: "8px" }}
                />
              ) : isPdf(getAttachmentUrl(selectedRecord)) ? (
                <iframe
                  src={getAttachmentUrl(selectedRecord)}
                  width="100%"
                  height="400px"
                  style={{ border: "none", borderRadius: "8px" }}
                  title="PDF Preview"
                >
                  Your browser does not support iframes.
                  <a href={getAttachmentUrl(selectedRecord)} target="_blank" rel="noopener noreferrer">
                    View PDF
                  </a>
                </iframe>
              ) : (
                <div className="file-attachment text-center">
                  <a href={getAttachmentUrl(selectedRecord)} target="_blank" rel="noopener noreferrer">
                    View Attachment
                  </a>
                </div>
              )}
            </div>
          )}
        </div>
      </Modal>

      <Modal
        title="Update Broadcast Message"
        visible={isEditModalVisible}
        onCancel={() => {
          setIsEditModalVisible(false);
          setFile(null);
        }}
        footer={false}
        width={800}
        className="square-modal"
      >
        <Spin spinning={isUpdating}>
          <Form
            form={form}
            layout="vertical"
            onFinish={updateBroadcast}
            className="global-form"
          >
            <Row gutter={20}>
              <Col span={12}>
                <Form.Item name="validFrom" label="Valid from" rules={[{ required: true, message: "Required" }]}>
                  <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="validTo" label="Valid to" rules={[{ required: true, message: "Required" }]}>
                  <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="broadcastTo" label="Broadcast to" rules={[{ required: true, message: "Required" }]}>
                  <Select
                    options={broadcastToOptions}
                    onChange={(val) => {
                      setBroadcastTo(val);
                      getHubCpZone(val);
                      form.setFieldValue("hub", []);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                {broadcastTo === "HUB" && (
                  <Form.Item name="hub" label="Hub names" rules={[{ required: true, message: "Required" }]}>
                    <Select
                      mode="multiple"
                      options={hubCpZoneList}
                      placeholder="Select Hubs"
                      maxTagCount={1}
                      maxTagPlaceholder={(omittedValues) => `... +${omittedValues.length}`}
                      showSearch
                      optionFilterProp="label"
                      className="small-dropdown"
                      allowClear
                    />
                  </Form.Item>
                )}
              </Col>
              <Col span={12} style={{ paddingTop: selectedHubs?.length > 1 ? "18px" : "0px" }}>
                <Form.Item name="title" label="Title" rules={[{ required: true, message: "Required" }]}>
                  <AntInput maxLength={70} />
                </Form.Item>
              </Col>
              <Col span={12} style={{ paddingTop: selectedHubs?.length > 1 ? "18px" : "0px" }}>
                <Form.Item name="priority" label="Priority" rules={[{ required: true, message: "Required" }]}>
                  <Select options={priorityOptions} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="message" label="Message">
                  <CKEditor
                    key={editorRefreshKey}
                    config={toolbarConfig}
                    editor={ClassicEditor}
                    data={messageData}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setMessageData(data);
                      form.setFieldsValue({ message: data });
                    }}
                  />
                  <div style={{ textAlign: "right" }}>{messageData.length}/350</div>
                </Form.Item>
              </Col>
            </Row>
            <div className="d-flex flex-end mt-1">
              {!file && getAttachmentUrl(editRecord) && !isExistingFileRemoved && (
                <span style={{ marginRight: "10px", display: "inline-flex", alignItems: "center" }}>
                  <span
                    style={{ color: "#1890ff", cursor: "pointer", maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                    onClick={() => window.open(getAttachmentUrl(editRecord), "_blank")}
                    title="View current attachment"
                  >
                    {getFileName(getAttachmentUrl(editRecord)) || "View Attachment"}
                  </span>
                  <CloseCircleOutlined
                    style={{ color: "#ff4d4f", marginLeft: "5px", cursor: "pointer" }}
                    onClick={removeExistingAttachment}
                  />
                </span>
              )}
              {file && (
                <span style={{ marginRight: "10px", display: "inline-flex", alignItems: "center" }}>
                  {file.name}
                  <CloseCircleOutlined
                    style={{ color: "#ff4d4f", marginLeft: "5px", cursor: "pointer" }}
                    onClick={() => {
                      setFile(null);
                      removeAttachmentDisplayOnly();
                    }}
                  />
                </span>
              )}
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={(e) => {
                  const selectedFile = e.target.files[0];
                  if (selectedFile) {
                    setFile(selectedFile);
                    setIsExistingFileRemoved(true);

                    const attachmentPattern = /(<br\s*\/?>)*(\s)*<b>Attachment:<\/b>.*$/gi;
                    const imagePattern = /(<br\s*\/?>)*(\s)*<img.*$/gi;
                    let cleanMessage = messageData
                      .replace(attachmentPattern, "")
                      .replace(imagePattern, "")
                      .trim();

                    if (selectedFile.type.startsWith("image/")) {
                      const objectUrl = URL.createObjectURL(selectedFile);
                      const updatedMessage = `${cleanMessage}<br/><br/><img src="${objectUrl}" style="max-width: 100%; height: auto; border-radius: 8px;">`;
                      setMessageData(updatedMessage);
                      form.setFieldsValue({ message: updatedMessage });
                      setEditorRefreshKey((prev) => prev + 1);
                    } else {
                      const updatedMessage = `${cleanMessage}<br/><br/><b>Attachment:</b> ${selectedFile.name}`;
                      setMessageData(updatedMessage);
                      form.setFieldsValue({ message: updatedMessage });
                      setEditorRefreshKey((prev) => prev + 1);
                    }
                  }
                }}
              />
              <AntButton icon={<PaperClipOutlined />} onClick={() => fileInputRef.current.click()} style={{ marginRight: "10px" }}>
                ATTACHMENT
              </AntButton>
              <AntButton type="primary" htmlType="submit">UPDATE</AntButton>
            </div>
          </Form>
        </Spin>
      </Modal>
    </div>
  );
};
export default ViewBroadcast;
